/* eslint-disable no-shadow */
/* eslint-disable eqeqeq */
import { ANONYMOUS_USER, NOSUSC_USER, SUSC_USER } from '../constants';
import { user } from '../actions/response';
import { getHKS } from './HKS';

// import { USERTYPE } from '../actions/constants_actions';

export class UserType {
  constructor(store) {
    Object.assign(this, {
      checkType() {
        let userData = {};

        let logged;
        if (localStorage.getItem('loginInfo.logged_user')) {
          logged = JSON.parse(localStorage.getItem('loginInfo.logged_user'));
        } else {
          logged = false;
        }

        if (localStorage.getItem('loginInfo.logged_user_data')) {
          userData = JSON.parse(
            localStorage.getItem('loginInfo.logged_user_data'),
          );
        }

        if (localStorage.getItem('loginInfo.userhash')) {
          userData.userhash = localStorage.getItem('loginInfo.userhash');
        }

        if (localStorage.getItem('loginInfo.region')) {
          userData.region = localStorage.getItem('loginInfo.region');
        }

        if (localStorage.getItem('loginInfo.profile')) {
          try {
            userData.profile = JSON.parse(
              localStorage.getItem('loginInfo.profile'),
            );
          } catch (err) {
            userData.profile = {};
          }
        }

        if (logged == false) {
          userData.userType = ANONYMOUS_USER;
          userData.is_user_logged_in = 0;
          delete userData.userhash;
          store.dispatch(user(userData));
          return;
        }

        if (userData.hasUserSusc == true) {
          userData.userType = SUSC_USER;
        } else {
          userData.userType = NOSUSC_USER;
        }

        store.dispatch(user(userData));
      },
    });
  }

  checkHks() {
    const hks = getHKS() ? getHKS() : null;
    return hks;
  }

  checkRegion() {
    const region = localStorage.getItem('loginInfo.region')
      ? localStorage.getItem('loginInfo.region')
      : 'mexico';

    return region;
  }

  checkIsLogged() {
    let isLogged = false;
    if (
      localStorage.getItem('loginInfo.logged_user') &&
      localStorage.getItem('loginInfo.logged_user_data')
    ) {
      const user = JSON.parse(
        localStorage.getItem('loginInfo.logged_user_data'),
      );
      if (user.username) {
        isLogged = true;
      }
    }
    return isLogged;
  }

  checkUserData() {
    let userData = {};
    try {
      userData = JSON.parse(
        window.localStorage.getItem('loginInfo.logged_user_data'),
      );
    } catch (e) {
      userData = {};
    }
    return userData;
  }
}
